import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideZoneChangeDetection } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { AuthHttpInterceptor, provideAuth0 } from "@auth0/auth0-angular";
import { environment } from "src/environments/environment";
import { ApplicationInsightsErrorHandler } from "src/services/application-insights-errorhandler.service";
import { ErrorLogHandler } from "src/services/httpdata.service";
import { routes } from "./app-routing.module";

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        // No withPreloading(): lazy routes load on demand only. Angular's default is
        // NoPreloading. Do not reintroduce PreloadAllModules - it ignores canMatch and
        // preloads loadComponent routes with no guard check, so it downloads every lazy
        // chunk for every signed-in user regardless of their permissions.
        provideRouter(routes, withComponentInputBinding()),
        provideAuth0({
            ...environment.auth,
            httpInterceptor: {
                allowedList: [`${environment.apiUrl}/*`, `${environment.platformApiUrl}/*`, `${environment.resourceApiUrl}*`, `${environment.realPropertyUrl}/*`],
            },
            cacheLocation: "localstorage"
        }),
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
        { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
        { provide: ErrorLogHandler, useClass: ApplicationInsightsErrorHandler },
        { provide: LOCALE_ID, useValue: "no" },
        provideHttpClient(withInterceptorsFromDi()),
    ],
};
